// removed by extract-text-webpack-plugin
module.exports = {"block":"VK_wmVjt0J1kAcYraCQp1"};